import React from 'react';
import { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import ResponseError from '../../shared/responses/ResponseError';
import ResponseResult from '../../shared/responses/ResponseResult';

import useGlobal from '../../store';
import TimbradoMasivoUploadForm from './archivos/upload/components/TimbradoMasivoUploadForm';

const mapState = (store) => {
  return {
    upload: store.modulo.timbrado_masivo.upload,
    archivos: store.modulo.timbrado_masivo.archivos,
  };
};

const mapActions = (actions) => {
  return {
    upload: actions.modulo.timbrado_masivo.upload,
    archivos: actions.modulo.timbrado_masivo.archivos,
  };
};

const TimbradoMasivoUpload = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { data, busy, result, error } = state.upload;

  const isValid = !!data.tipo && !!data.file;

  useEffect(() => {
    return () => {
      actions.upload.reset();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClose = () => {
    if (!busy) {
      props.history.replace('/modulos/timbrado-masivo/archivos');
    }
  };

  const upload = () => {
    actions.upload.upload((event) => {
      actions.upload.progress(Math.round((100 * event.loaded) / event.total));
    });
  };

  useEffect(() => {
    if (!!result && state.archivos.pagination.page === 1) {
      actions.archivos.paginate({});
    }
  }, [result]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!!result) {
    return (
      <div className="result-container">
        <ResponseResult
          title="Archivo enviado"
          result={result}
          onAction={handleClose}
        />
      </div>
    );
  }

  if (!!error) {
    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={handleClose}
        />
      </div>
    );
  }

  return (
    <>
      <Modal
        backdrop="static"
        keyboard={false}
        show={true}
        centered={true}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Subir archivo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TimbradoMasivoUploadForm />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            disabled={busy}
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            variant="primary"
            disabled={busy || !isValid}
            onClick={upload}
          >
            Subir
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TimbradoMasivoUpload;
